module.exports = __webpack_public_path__ + "img/sld_mppt_2_t1_green.446c2643.svg";